import { Icon } from "components/lib";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import styles from "./styles.module.scss";

export function Pagination(props) {
  const [active, setActive] = useState(props.active);
  const [pages, setPages] = useState([]);

  useEffect(() => {
    if (props.pagesCount === 1) {
      setPages([0]);
    } else {
      setPages(Array.from(Array(props.pagesCount).keys()).slice(0, 5));
    }
  }, []);

  return (
    <div className={styles.container}>
      <div
        className={styles.left}
        onClick={() => {
          if (active !== 1) {
            props.onChange(active - 1);
            setActive(active - 1);

            if (pages[0] + 1 !== 1 && active === pages[0] + 1) {
              setPages(
                [pages[0] - 1]
                  .concat(pages)
                  .filter((item) => item !== pages[pages.length - 1])
              );
            }
          }
        }}
        style={
          props.pagesCount >= 2 && active !== 1
            ? { display: "flex" }
            : { display: "none" }
        }
      >
        <Icon image="chevron-left" size={20} color="#838995" />
      </div>
      <div className={styles.pages}>
        {pages.map((value, index) => {
          value = value + 1;

          return (
            <div
              className={value === active ? styles.active : styles.page}
              key={uuidv4()}
              onClick={() => {
                if (value === active) return;

                props.onChange(value);
                setActive(value);

                if (
                  pages[0] + 1 !== 1 &&
                  (pages[0] + 1 === value || pages[0] + 2 === value)
                ) {
                  setPages(
                    [pages[0] - 1]
                      .concat(pages)
                      .filter((item) => item !== pages[pages.length - 1])
                  );
                }

                if (
                  value === pages[pages.length - 1] + 1 &&
                  value <= props.pagesCount - 1
                ) {
                  setPages(pages.shift());
                  setPages([...pages, value]);
                }
              }}
            >
              {value}
            </div>
          );
        })}
      </div>
      <div
        className={styles.right}
        style={
          props.pagesCount >= 2 && active !== props.pagesCount
            ? { display: "flex" }
            : { display: "none" }
        }
        onClick={() => {
          if (active !== props.pagesCount) {
            props.onChange(active + 1);
            setActive(active + 1);

            if (
              active === pages[pages.length - 1] + 1 &&
              pages[pages.length - 1] !== props.pagesCount - 1
            ) {
              setPages(pages.shift());
              setPages([...pages, active]);
            }
          }
        }}
      >
        <Icon image="chevron-right" size={20} color="#838995" />
      </div>
    </div>
  );
}
